export default function pageSupport($rootScope) {
  'ngInject';

  return {
    scope: {},
    link: function () {
      const el = $('html');
      const support = [{
          support: 'flexPage',
          class: 'support-flex-page'
        },
        {
          support: 'breadcrumb',
          class: 'support-breadcrumb'
        },
        {
          support: 'leftNav',
          class: 'support-left-nav'
        }
      ];

      if (el) {
        support.forEach(supp => {
          if ($rootScope[supp.support]) {
            el.addClass(supp.class);
          } else {
            el.removeClass(supp.class);
          }
        });
      }
    }
  };
}